name: CI/CD & Automation
quadrant: 3
entries:
  - label: Docker
    description: >
      <a href="https://www.docker.com/">Docker</a> is a platform that automates
      the deployment and management of applications within lightweight, portable
      containers, ensuring consistency across different environments.

      Our entire infrastructure is built using Docker, making it the default
      method for both deploying and locally developing software,
    ring: adopt
    active: true
    moved: 0
  - label: GitLab CI/CD
    description: >
      <a href="https://docs.gitlab.com/ee/ci/">GitLab CI/CD</a>  is an
      integrated toolset for continuous integration and continuous delivery,
      enabling automated testing, building, and deployment of code within
      GitLab.

      It is the default platform we use to manage and develop all of our
      closed-source software, ensuring consistency and efficiency across our
      products, esuring our projects are healthy and meet our quality standards.
    ring: adopt
    active: true
    moved: 0
  - label: Blackfire
    description: >
      <a href="https://www.blackfire.io/">Blackfire</a> is a powerful
      performance profiling and monitoring tool that offers deep insights into
      your application's execution. It helps developers identify performance
      bottlenecks, optimize resource usage, and ensure efficient code execution,
      making it an essential tool for performance management.

      Teams are encouraged to adopt Blackfire, especially when fine-tuning
      application performance is a priority or when preparing for increased
      load. Its seamless integration into development workflows makes it ideal
      for both continuous performance monitoring and proactive optimization.
    ring: adopt
    active: true
    moved: 2
  - label: Dependency-Track
    description: >
      <a href="https://dependencytrack.org">Dependency-Track</a> is a robust,
      open-source software composition analysis tool that continuously monitors
      and analyzes third-party components in your applications to identify and
      manage vulnerabilities and compliance risks.

      Teams should adopt Dependency-Track as it provides critical insights into
      the security and integrity of software dependencies, enabling proactive
      risk management and ensuring that security and compliance standards are
      consistently met.
    ring: adopt
    active: true
    moved: 2
  - label: Renovate
    description: >
      <a href="https://renovatebot.com">Renovate</a> is an open-source tool that
      automates the process of dependency updates by continuously scanning your
      repositories and creating pull requests for outdated packages. This
      streamlines maintenance and ensures that projects remain secure and
      up-to-date.

      Teams are encouraged to adopt Renovate because it significantly reduces
      manual effort, minimizes technical debt, and helps maintain code security
      by automating dependency management.
    ring: adopt
    active: true
    moved: 2
  - label: Open Telemetry
    description: >
      <a href="https://opentelemetry.io">OpenTelemetry</a> is an open-source
      framework that standardizes the collection and correlation of metrics,
      logs, and traces across distributed systems, enabling better observability
      and performance monitoring.

      After a successful trial phase, OpenTelemetry has proven its capability to
      streamline our monitoring and diagnostics. Teams are encouraged to adopt
      OpenTelemetry for unified observability across distributed systems,
      providing comprehensive insights into system performance, metrics, logs,
      and traces.
    ring: adopt
    active: true
    moved: 1
